import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "./SingleServiceComponents/ConfirmDeleteModal";
import sericesApi from "../../api/service/service.api";
import toast from "react-hot-toast";
import ProcessingBar2 from "../ProcessingBar/ProcessingBar2";
import menuApi from "../../api/menu/menu.api";

const ServiceDropdown = ({
  onClose,
  service,
  onDeleted,
  onDuplicated,
  onUpdated,
}) => {
  const serviceId = service._id;
  console.log({ service });
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoadingActive, setIsLoadingActive] = useState(false);

  const serviceDetail = service;

  const handleToggleActive = async () => {
    if (isLoadingActive) return; // 🚫 prevent spam click

    try {
      setIsLoadingActive(true); // ✅ start loading

      const newStatus = !service.isActive;

      await menuApi.updateMenuItem(service._id, {
        isActive: newStatus,
      });

      toast.success(service.isActive ? "Item archived" : "Item activated");

      if (onUpdated) {
        onUpdated(service._id, newStatus);
      }

      onClose();
    } catch (err) {
      toast.error("Failed to update status");
      console.error(err);
    } finally {
      setIsLoadingActive(false); // ✅ stop loading
    }
  };

  const handleDelete = async () => {
    if (isLoading) return; // 🚫 prevent double click

    try {
      setIsLoadingDelete(true); // ✅ start loader

      await menuApi.deleteMenuItem(serviceId);
      setShowConfirm(false);
      onClose();
      if (onDeleted) onDeleted(serviceId); // ✅ tell parent to update list
      console.log("Service deleted successfully");
    } catch (err) {
      console.error("Failed to delete service", err);
    } finally {
      setIsLoadingDelete(false); // ✅ stop loader no matter what
    }
  };

  const handleDuplicate = async () => {
    if (isLoading) return; // 🚫 stop if already loading

    try {
      setIsLoading(true);
      const res = await menuApi.getMenuItemDetail(serviceId);
      const service = res?.foodItem; // ✅ FIX

      if (!service) {
        console.error("Service not found for duplication");
        return;
      }

      const { _id, createdAt, updatedAt, ...cloneData } = service;

      cloneData.title = `${cloneData.title} (Copy)`;

      // create new service
      const newServiceResponse = await menuApi.createMenuItem(cloneData);

      // unwrap the actual service
      const newService = newServiceResponse?.foodItem;

      toast.success("Item duplicated successfully");

      // push new service into parent list
      if (onDuplicated) onDuplicated(newService);

      onClose();
    } catch (err) {
      toast.error("Failed to duplicate Item");
      console.error("Failed to duplicate Item", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Desktop dropdown */}
      <div className="hidden md:block absolute right-0 top-8 w-48 bg-dry border border-border rounded-lg shadow-lg z-20">
        <ul className="text-sm text-text ">
          <li
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer hover:text-redlight"
            onClick={() => {
              navigate(`/food/item/edit/${serviceId}`);
              onClose();
            }}
          >
            Edit
          </li>
          <li
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer hover:text-redlight"
            onClick={!isLoading ? handleDuplicate : undefined}
          >
            {isLoading ? (
              <div className="ml-8 my-2 bg-dry">
                <ProcessingBar2 />
              </div>
            ) : (
              "Duplicate"
            )}
          </li>
          <li
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer hover:text-redlight"
            onClick={!isLoadingActive ? handleToggleActive : undefined}
          >
            {isLoadingActive ? (
              <div className="ml-6 my-1">
                <ProcessingBar2 />
              </div>
            ) : service?.isActive ? (
              "UnArchive"
            ) : (
              "Archive"
            )}
          </li>
          <li
            className="px-4 py-2 text-red-600 hover:bg-red-50 cursor-pointer font-medium hover:text-redlight"
            onClick={() => setShowConfirm(true)}
          >
            Permanently delete
          </li>
        </ul>
      </div>

      {/* Mobile bottom sheet */}
      <div className="fixed inset-0 z-50 flex items-end md:hidden">
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-black bg-opacity-40"
          onClick={onClose}
        />

        {/* Bottom Sheet */}
        <div className="relative w-full bg-dry rounded-t-lg shadow-lg p-4 max-h-[70%] overflow-y-auto animate-slideUp">
          {/* Close button */}
          <div className="flex justify-end">
            <button onClick={onClose} className="text-text text-lg font-bold">
              ✕
            </button>
          </div>

          <ul className="text-sm text-text">
            <li
              className="px-4 py-3 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                navigate(`/food/item/edit/${serviceId}`);
                onClose();
              }}
            >
              Edit
            </li>
            <li
              className="px-4 py-3 hover:bg-gray-100 cursor-pointer"
              onClick={handleDuplicate}
            >
              Duplicate
            </li>
            {/* <li className="px-4 py-3 hover:bg-gray-100 cursor-pointer">
              Quick booking link
            </li> */}
            <li
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer hover:text-redlight"
              onClick={!isLoadingActive ? handleToggleActive : undefined}
            >
              {isLoadingActive ? (
                <div className="ml-6 my-1 bg-dry">
                  <ProcessingBar2 />
                </div>
              ) : service?.isActive ? (
                "UnArchive"
              ) : (
                "Archive"
              )}
            </li>
            <li
              className="px-4 py-3 text-red-600 hover:bg-red-50 cursor-pointer font-medium"
              onClick={() => setShowConfirm(true)}
            >
              Permanently delete
            </li>
          </ul>
        </div>
      </div>

      {/* Confirm Delete Modal */}
      <ConfirmDeleteModal
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleDelete}
        isLoading={isLoadingDelete} // ✅ pass loading state
      />
    </>
  );
};

export default ServiceDropdown;
